import { ConsentsClient } from '../clients';
import type { IAcceptAllOfficeConsentsParameters } from '../types/OfficeConsent.parameters';

export const acceptAllOfficeConsents = async (
  params: IAcceptAllOfficeConsentsParameters,
): Promise<void> => {
  await ConsentsClient.acceptAllOfficeConsents(params);
};
